// src/lib/roi.ts
import type { Deal } from './types'

/**
 * Coût par install.
 * Retourne null si budget ou installs absent/zéro.
 */
export function cpi(budget: number | null, installs: number | null): number | null {
  if (budget === null || installs === null || installs === 0) return null
  return budget / installs
}

export type DealRoiResult = {
  installs: number
  views: number
  revenue: number
  cpi: number | null
  conversionRate: number | null
}

/**
 * Agrège les deliverables d'un deal pour calculer le ROI global.
 * Type A (own_audience) : installs + revenus attribués.
 * Type B (our_channels) : vues des canaux OTIA.
 */
export function dealRoi(deal: Deal): DealRoiResult {
  let installs = 0
  let views = 0
  let revenue = 0

  for (const d of deal.deliverables) {
    views += d.views ?? 0
    installs += d.installsAttributed ?? 0
    revenue += d.revenueAttributed ?? 0
  }

  const computedCpi = cpi(deal.amount, installs > 0 ? installs : null)
  const conversionRate = views > 0 && installs > 0 ? installs / views : null

  return { installs, views, revenue, cpi: computedCpi, conversionRate }
}
